module.exports = __webpack_public_path__ + "img/EventWinPage1128.700e612f.png";